<template>
  <div class="auth-page">
    <div class="container page d-flex h-100">
      <div class="row w-100 align-items-center">
        <div class="col-md-6 offset-md-3 col-xs-12">
          <card title="Reset Password">
            <form v-on:submit.prevent="onSubmit">
              <fieldset>
                <div class="form-group">
                  <input
                    class="form-control form-control-lg"
                    type="email"
                    v-model="user.email"
                    placeholder="Email"
                  />
                </div>
              </fieldset>
              <button class="btn btn-primary pull-xs-right">
                Reset Password
              </button>
              <p class="text-xs-center mt-4">
                <router-link :to="{ name: 'login' }">
                  Back to login
                </router-link>
              </p>
            </form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { USER_RESET_PASSWORD } from "@/store/actions.type";

export default {
  data() {
    return {
      user: {
        email: ''
      }
    };
  },
  methods: {
    onSubmit() {
      this.$store.dispatch(USER_RESET_PASSWORD, this.user);
    }
  },
} 
</script>
<style lang="scss" scoped>
.auth-page {
  background-color: #dee5ed;
  background-image: linear-gradient(124deg, #dee5ed 0%, #bfdeff 100%);
  height: 100vh;
}
</style>
